module.exports = __webpack_public_path__ + "img/4_94.52fd7c6f.png";